export const UNIVERSAL_SEARCH = {
  TRIGGER: 'universal-search-trigger',
  POPOVER: 'universal-search-popover',
  SEARCH_INPUT: 'universal-search-input',
  CLEAR_BUTTON: 'universal-search-clear-button',
  NO_RESULTS: 'universal-search-no-results',
  ELEMENTS_HEADER: 'universal-search-elements-header',
  NOTES_HEADER: 'universal-search-notes-header',
  COMMENTS_HEADER: 'universal-search-comments-header',
  COLUMNS_HEADER: 'universal-search-columns-header',
  ELEMENTS_HEADER_COUNT: 'universal-search-elements-header-count',
  NOTES_HEADER_COUNT: 'universal-search-notes-header-count',
  COMMENTS_HEADER_COUNT: 'universal-search-comments-header-count',
  COLUMNS_HEADER_COUNT: 'universal-search-columns-header-count',
  ELEMENT_RESULT: 'universal-search-element-result',
  NOTE_RESULT: 'universal-search-note-result',
  COMMENT_RESULT: 'universal-search-comment-result',
  COLUMN_RESULT: 'universal-search-column-result',
  ELEMENT_TYPE_ICON: 'universal-search-element-type-icon',
  NOTE_ELEMENT_NAME: 'universal-search-note-element-name',
  COMMENT_USERNAME: 'universal-search-comment-username',
  COMMENT_DATE: 'universal-search-comment-date',
  COMMENT_ELEMENT_NAME: 'universal-search-comment-element-name',
  COLUMN_TAB_NAME: 'universal-search-column-tab-name',
  PARENT_TOOLTIP: 'universal-search-parent-tooltip'
} as const;
